import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useRecoilValue } from 'recoil'

import { langState } from 'src/data/common/commonAtoms'

const LangManager = (): JSX.Element => {
  const { i18n } = useTranslation()
  const lang = useRecoilValue(langState)
  useEffect(() => {
    i18n.changeLanguage(lang)
  }, [lang, i18n])
  return <></>
}

export default LangManager
